import React from "react"
import { Row, Col } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { chooseBenefitHeader } from "../../redux/actions"
import * as Constants from "../../common/constants"
//import GatsbyConfig from "../../../gatsby-config"

const BenefitGroupSelection = ({ claimData, uiData }) => {
  const {
    pageNumber,
    coverageHeaderList,
    chosenedBenefits,
    hideHeaderFooter,
  } = uiData

  const dispatch = useDispatch()

  const headerIsChosen = Id => {
    const result = chosenedBenefits.find(e => e["CoverageHeaderId"] === Id)
    return typeof result !== "undefined" ? true : false
  }

  const iconClassName = Id => {
    switch (Id) {
      case Constants.passedAwayCoverageHeaderId:
        return "PassedAwayCoverage"
      case Constants.insuredDisabledCoverageHeaderId:
        return "InsuredDisabledCoverage"
      case Constants.requiredMedicalAttentionCoverageHeaderId:
        return "RequiredMedicalAttentionCoverage"
      case Constants.childCoverageHeaderId:
        return "ChildCoverage"
      case Constants.lossAndDamageOfBicycleCoverageHeaderId:
        return "LossAndDamageOfBicycleCoverage"
      case Constants.optionalCoverageHeaderId:
        return "OptionalCoverage"
      case Constants.otherCoverageHeaderId:
        return "OtherCoverage"
      default:
        break
    }
  }

  const getNoOfCoverageUserSelected = coverageHeaderId => {
    let noOfCoverageSelected = 0

    chosenedBenefits.forEach((item, key) => {
      if (item.CoverageHeaderId === coverageHeaderId) {
        noOfCoverageSelected += 1
      }
    })

    return noOfCoverageSelected
  }

  const routeToBenefitDetail = (coverageHeaderId, coverageHeaderName) => {
    dispatch(chooseBenefitHeader(coverageHeaderId, coverageHeaderName))
  }

  const checkCoverageIsValid = coverageHeaderId => {
    switch (coverageHeaderId) {
      default:
        return true
    }
  }

  const createCoverageHeader = () => {
    let coverageHeaderArray = []

    coverageHeaderList.forEach((item, key) => {
      if (
        // item.CoverageHeaderName !== Constants.basicCoverageDetailName &&
        item.IsValid === true &&
        checkCoverageIsValid(item.CoverageHeaderId)
      ) {
        coverageHeaderArray.push(
          <Col
            xs={12}
            md={3}
            key={key}
            onClick={() => {
              routeToBenefitDetail(
                item.CoverageHeaderId,
                item.CoverageHeaderName
              )
            }}
            className="p-2"
          >
            {/*outer card container*/}
            <div className={
                "ClaimTypeCard " +
                (headerIsChosen(item.CoverageHeaderId) ? "outerChecked" : "")
            }
            >
                <div
                  className={
                    "ClaimtTypeIcon " +
                    iconClassName(item.CoverageHeaderId) +
                    " " +
                    (headerIsChosen(item.CoverageHeaderId) ? "Checked" : "")
                  }
                >
                  {headerIsChosen(item.CoverageHeaderId) && (
                    <span className="selectedBorder">
                      {" "}
                      {getNoOfCoverageUserSelected(
                        item.CoverageHeaderId
                      )} selected{" "}
                    </span>
                  )}
                </div>
                <p className="text-center ClaimTypeIconText mt-3">
                  {item.CoverageHeaderName}
                </p>
            </div>
          </Col>
        )
      }
    })
    return coverageHeaderArray
  }

  return (
    <Row
      className={pageNumber === Constants.benefitGroupPageNumber ? "" : "hide"}
    >
      <div
        className={
          "title text-center " +
          " " +
          (hideHeaderFooter ? "MarginTop15" : "MarginTop75")
        }
      >
        Select the claim type you wish to submit
      </div>
      <Row className="containerBody formContainerLightYellow marginTop3x pb-0">
        <Col
          xs={{ span: 12, offset: 0 }}
          md={{ span: 12, offset: 0 }}
          className="coverageContainer"
        >
          <div className="horizontal-align">
            <Col xs={12} md={12}>
              <div className="titleText">
                {/* Personal Accident claim type */}
              </div>
            </Col>
          </div>
          <div>
            <Row>{createCoverageHeader()}</Row>
          </div>
        </Col>
      </Row>
    </Row>
  )
}

export default BenefitGroupSelection
